import template from "./proxy-response-operation-result.html";
function Controller($logger) {
	const ctrl = this;

	ctrl.$onInit = () => {
		if(ctrl.content === null || ctrl.content === undefined) {
			return;
		}

		if(!!ctrl.content.Data) {
			try {
				ctrl.pretty = JSON.stringify(ctrl.content.Data, null, 2);
			}
			catch(e) {
				ctrl.pretty = String(ctrl.content.Data);
			}
		}
	};
}

export default angular.module("vesl.components.proxy-response-operation-result", []).component("proxyResponseOperationResult", {
	bindings: {
		content: "<"
	},
	controller: Controller,
	template
}).name;
